<template>
    <v-card color="#00355e">
        <v-card-title class="white--text">
            <span class="white--text">Pedidos</span>

            <v-spacer></v-spacer>

            <span class="white--text">Ultimos 7 dias</span>
        </v-card-title>
        <v-card-text class="white--text display-1">
            {{ total }}
        </v-card-text>
        <apexchart type="area" height="100" :options="options" :series="series"></apexchart>
    </v-card>
</template>

<script>
    export default {
        components: {},

        data() {
            return {
                options: {
                    chart: {
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: false
                        },
                        sparkline: {
                            enabled: true
                        }
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    tooltip: {
                        enabled: true,
                        x: {
                            show: true,
                            formatter: (a, b) => this.$moment(this.series[b.seriesIndex].data[b.dataPointIndex].x).format('dddd D')
                        },
                        y: {
                            formatter: (a) => a + ' Pedidos',
                            title: {
                                formatter: (seriesName) => ''
                            }
                        },
                        marker: {
                            show: false
                        }
                    },
                    yaxis: {
                        min: 0
                    }
                },
                series: []
            };
        },

        props: {
            stats: {
                type: Array,
                default: () => []
            }
        },

        computed: {
            total() {
                return this.stats.reduce((a, v) => {
                    return a + v.orders;
                }, 0);
            }
        },

        watch: {
            stats(result) {
                // console.log("last sunday: " + moment().day(-7).format("dddd, MMMM Do YYYY"));
                // console.log('Week: ' + moment().isoWeek());

                let series = [];
                for(let i = 0; i < result.length; ++i) {
                    series.push({
                        x: result[i].date,
                        y: result[i].orders
                    });
                }

                this.series = [{
                    data: series
                }];
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
